import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';

@Component({
    selector: 'app-empty',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss'],
    standalone: false
})
export class EmptyComponent extends BaseControlComponent implements OnInit {
    static componentName = 'EmptyComponent';

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
    }
}
